import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "app-container"
};
import { useRoute } from 'vue-router';
import appMain from './components/AppMain.vue';
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import ChatBot from '@/layout/components/ChatBot.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup (__props) {
        const $route = useRoute();
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                false ? (_openBlock(), _createBlock(ChatBot, {
                    key: 0
                })) : _createCommentVNode("", true),
                _createVNode(Navbar),
                _createElementVNode("div", {
                    class: _normalizeClass([
                        "flex-1",
                        {
                            'content-container': _unref($route).meta.tabbar
                        }
                    ])
                }, [
                    _createVNode(appMain)
                ], 2),
                !_unref($route).meta.hideFooter ? (_openBlock(), _createBlock(Footer, {
                    key: 1
                })) : _createCommentVNode("", true)
            ]);
        };
    }
});
